/* @generated from adl module ferovinum.app.uiconfig */

import * as ADL from './../../runtime/adl';
import * as ferovinum_app_config from './config';
import * as ferovinum_app_db from './db';
import * as sys_types from './../../sys/types';

/**
 * Configuration for the web frontend.
 */
export interface UiConfig {
  /**
   * Application title
   */
  title: string;
  /**
   * The URL of the trade sale terms and conditions PDF
   */
  ferovinumTermsAndConditionsUrl: string;
  /**
   * The URL of the user manual
   */
  userManualUrl: string;
  /**
   * Environment name, e.g. dev, uat, prod
   */
  environment: string;
  /**
   * Name of the release / code version
   */
  releaseName: string;
  hotjarConfig: ferovinum_app_config.HotjarConfig;
  /**
   * Google Analytics configuration
   */
  googleAnalyticsConfig: ferovinum_app_config.GoogleAnalyticsConfig;
  /**
   * PostHog configuration
   */
  postHogConfig: PublicPostHogConfig;
  /**
   * API domain URL eg. https://api.fero.capital
   */
  apiDomainUrl: string;
  fronteggConfig: FronteggConfig;
  terminologyMapping: sys_types.Map<ferovinum_app_db.MasterAgreementVersion, TerminologyLookup>;
}

export function makeUiConfig(
  input: {
    title?: string,
    ferovinumTermsAndConditionsUrl?: string,
    userManualUrl?: string,
    environment: string,
    releaseName: string,
    hotjarConfig: ferovinum_app_config.HotjarConfig,
    googleAnalyticsConfig: ferovinum_app_config.GoogleAnalyticsConfig,
    postHogConfig: PublicPostHogConfig,
    apiDomainUrl: string,
    fronteggConfig: FronteggConfig,
    terminologyMapping: sys_types.Map<ferovinum_app_db.MasterAgreementVersion, TerminologyLookup>,
  }
): UiConfig {
  return {
    title: input.title === undefined ? "" : input.title,
    ferovinumTermsAndConditionsUrl: input.ferovinumTermsAndConditionsUrl === undefined ? "https://com-hx-ferovinum-assets.s3.eu-west-2.amazonaws.com/files/ferovinum-general_terms_and_conditions_2025.pdf" : input.ferovinumTermsAndConditionsUrl,
    userManualUrl: input.userManualUrl === undefined ? "https://amusing-poppy-236.notion.site/ebd//30482543f57a81c283ebe13de22c6075" : input.userManualUrl,
    environment: input.environment,
    releaseName: input.releaseName,
    hotjarConfig: input.hotjarConfig,
    googleAnalyticsConfig: input.googleAnalyticsConfig,
    postHogConfig: input.postHogConfig,
    apiDomainUrl: input.apiDomainUrl,
    fronteggConfig: input.fronteggConfig,
    terminologyMapping: input.terminologyMapping,
  };
}

const UiConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.uiconfig","decl":{"annotations":[{"value":"Configuration for the web frontend.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Application title\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"title","default":{"kind":"just","value":""},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The URL of the trade sale terms and conditions PDF\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"ferovinumTermsAndConditionsUrl","default":{"kind":"just","value":"https://com-hx-ferovinum-assets.s3.eu-west-2.amazonaws.com/files/ferovinum-general_terms_and_conditions_2025.pdf"},"name":"ferovinumTermsAndConditionsUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The URL of the user manual\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"userManualUrl","default":{"kind":"just","value":"https://amusing-poppy-236.notion.site/ebd//30482543f57a81c283ebe13de22c6075"},"name":"userManualUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Environment name, e.g. dev, uat, prod\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Name of the release / code version\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"releaseName","default":{"kind":"nothing"},"name":"releaseName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"hotjarConfig","default":{"kind":"nothing"},"name":"hotjarConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"HotjarConfig"}},"parameters":[]}},{"annotations":[{"value":"Google Analytics configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"googleAnalyticsConfig","default":{"kind":"nothing"},"name":"googleAnalyticsConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.config","name":"GoogleAnalyticsConfig"}},"parameters":[]}},{"annotations":[{"value":"PostHog configuration\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"postHogConfig","default":{"kind":"nothing"},"name":"postHogConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.uiconfig","name":"PublicPostHogConfig"}},"parameters":[]}},{"annotations":[{"value":"API domain URL eg. https://api.fero.capital\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"apiDomainUrl","default":{"kind":"nothing"},"name":"apiDomainUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"fronteggConfig","default":{"kind":"nothing"},"name":"fronteggConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.uiconfig","name":"FronteggConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"terminologyMapping","default":{"kind":"nothing"},"name":"terminologyMapping","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MasterAgreementVersion"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.uiconfig","name":"TerminologyLookup"}},"parameters":[]}]}}]}},"name":"UiConfig","version":{"kind":"nothing"}}};

export const snUiConfig: ADL.ScopedName = {moduleName:"ferovinum.app.uiconfig", name:"UiConfig"};

export function texprUiConfig(): ADL.ATypeExpr<UiConfig> {
  return {value : {typeRef : {kind: "reference", value : snUiConfig}, parameters : []}};
}

export interface PublicPostHogConfig {
  /**
   * Client side key
   */
  publicKey: string;
  host: string;
}

export function makePublicPostHogConfig(
  input: {
    publicKey: string,
    host: string,
  }
): PublicPostHogConfig {
  return {
    publicKey: input.publicKey,
    host: input.host,
  };
}

const PublicPostHogConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.uiconfig","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Client side key\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"publicKey","default":{"kind":"nothing"},"name":"publicKey","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PublicPostHogConfig","version":{"kind":"nothing"}}};

export const snPublicPostHogConfig: ADL.ScopedName = {moduleName:"ferovinum.app.uiconfig", name:"PublicPostHogConfig"};

export function texprPublicPostHogConfig(): ADL.ATypeExpr<PublicPostHogConfig> {
  return {value : {typeRef : {kind: "reference", value : snPublicPostHogConfig}, parameters : []}};
}

export interface FronteggConfig {
  /**
   * The App ID in Frontegg to use with the Frontegg SDK for authentication
   */
  mainAppId: string;
  /**
   * The Base URL of the Frontegg environment to connect to for authentication
   */
  baseUrl: string;
  /**
   * The environment's path segment in the Frontegg portal, e.g. "development"
   */
  fronteggPortalEnvironment: (string|null);
}

export function makeFronteggConfig(
  input: {
    mainAppId: string,
    baseUrl: string,
    fronteggPortalEnvironment?: (string|null),
  }
): FronteggConfig {
  return {
    mainAppId: input.mainAppId,
    baseUrl: input.baseUrl,
    fronteggPortalEnvironment: input.fronteggPortalEnvironment === undefined ? null : input.fronteggPortalEnvironment,
  };
}

const FronteggConfig_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.uiconfig","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The App ID in Frontegg to use with the Frontegg SDK for authentication\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"mainAppId","default":{"kind":"nothing"},"name":"mainAppId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The Base URL of the Frontegg environment to connect to for authentication\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"baseUrl","default":{"kind":"nothing"},"name":"baseUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"The environment's path segment in the Frontegg portal, e.g. \"development\"\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"fronteggPortalEnvironment","default":{"kind":"just","value":null},"name":"fronteggPortalEnvironment","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"FronteggConfig","version":{"kind":"nothing"}}};

export const snFronteggConfig: ADL.ScopedName = {moduleName:"ferovinum.app.uiconfig", name:"FronteggConfig"};

export function texprFronteggConfig(): ADL.ATypeExpr<FronteggConfig> {
  return {value : {typeRef : {kind: "reference", value : snFronteggConfig}, parameters : []}};
}

export interface TerminologyLookup {
  forwardSalePrice: string;
  compulsorySale: string;
  compulsorySaleDate: string;
  expiryDate: string;
  deposit: string;
  expiringDeals: string;
  netAdvance: string;
  throughputFee: string;
}

export function makeTerminologyLookup(
  input: {
    forwardSalePrice: string,
    compulsorySale: string,
    compulsorySaleDate: string,
    expiryDate: string,
    deposit: string,
    expiringDeals: string,
    netAdvance: string,
    throughputFee: string,
  }
): TerminologyLookup {
  return {
    forwardSalePrice: input.forwardSalePrice,
    compulsorySale: input.compulsorySale,
    compulsorySaleDate: input.compulsorySaleDate,
    expiryDate: input.expiryDate,
    deposit: input.deposit,
    expiringDeals: input.expiringDeals,
    netAdvance: input.netAdvance,
    throughputFee: input.throughputFee,
  };
}

const TerminologyLookup_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.uiconfig","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"forwardSalePrice","default":{"kind":"nothing"},"name":"forwardSalePrice","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"compulsorySale","default":{"kind":"nothing"},"name":"compulsorySale","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"compulsorySaleDate","default":{"kind":"nothing"},"name":"compulsorySaleDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"expiryDate","default":{"kind":"nothing"},"name":"expiryDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"deposit","default":{"kind":"nothing"},"name":"deposit","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"expiringDeals","default":{"kind":"nothing"},"name":"expiringDeals","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"netAdvance","default":{"kind":"nothing"},"name":"netAdvance","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"throughputFee","default":{"kind":"nothing"},"name":"throughputFee","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"TerminologyLookup","version":{"kind":"nothing"}}};

export const snTerminologyLookup: ADL.ScopedName = {moduleName:"ferovinum.app.uiconfig", name:"TerminologyLookup"};

export function texprTerminologyLookup(): ADL.ATypeExpr<TerminologyLookup> {
  return {value : {typeRef : {kind: "reference", value : snTerminologyLookup}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.uiconfig.UiConfig" : UiConfig_AST,
  "ferovinum.app.uiconfig.PublicPostHogConfig" : PublicPostHogConfig_AST,
  "ferovinum.app.uiconfig.FronteggConfig" : FronteggConfig_AST,
  "ferovinum.app.uiconfig.TerminologyLookup" : TerminologyLookup_AST
};
